const StatusDisplay = ({ status }) => {
  const getColor = (status) => {
    let color
    switch (status) {
      case 'Complete ✅':
        color = '#00EEAA'
        break
      case 'In Progress':
        color = '#FFD70F'
        break
      case 'Stuck ❗':
        color = '#FF000F'
        break
      case 'Pending ...':
        color = '#DCB'
        break
        default:
          break
    }
    return color
  }

  return (
    <div
      className="status-display"
      style={{ backgroundColor: getColor(status) }}
    >
      {status}
    </div>
  )
}

export default StatusDisplay
